module.exports = __webpack_public_path__ + "img/gold4.fa6277ee.png";